// Rejection sampling avoids modulo bias; no password is stored or sent until Save.
const alphabet='ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%&*+-=?';
const passwordLength=6;
export const suggestTraderPassword=()=>{
  if(!globalThis.crypto?.getRandomValues)throw new Error('Güvenli şifre üretimi bu tarayıcıda kullanılamıyor. Şifreyi elle girin.');
  const limit=256-256%alphabet.length;
  for(let attempt=0;attempt<128;attempt++){
    let password='';
    for(let batch=0;batch<16&&password.length<passwordLength;batch++){
      const bytes=globalThis.crypto.getRandomValues(new Uint8Array(64));
      for(const value of bytes){if(value<limit)password+=alphabet[value%alphabet.length];if(password.length===passwordLength)break;}
    }
    if(password.length===passwordLength&&/[A-Z]/.test(password)&&/[a-z]/.test(password)&&/[0-9]/.test(password)&&/[^A-Za-z0-9]/.test(password))return password;
  }
  throw new Error('Güvenli şifre üretilemedi. Tekrar deneyin veya elle girin.');
};